import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextCharLimit} from 'views/components';
import {translate} from 'views/module';

const ContentNew = (props) => {
  const careviewItem = props.careviewItem;
  const setCareviewItem = props.setCareviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;

  const setQuestionTitle = (value) => {
    setCareviewItem((e) => {
      return {
        ...e,
        questionTitle: value,
      };
    });
  };

  return (
    <Box>
      <Stack>
        <TextCharLimit
          label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          placeholder={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          value={questionTitle}
          onChange={setQuestionTitle}
          charLimit={180}
          autoFocus
          fullWidth
        />
      </Stack>
    </Box>
  );
};

ContentNew.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setCareviewItem: PropTypes.func.isRequired,
};
export default React.memo(ContentNew);
